import { SupportedLanguage } from './SupportedLanguage';

export function parseSupportedLanguage(
  value: string,
): SupportedLanguage | undefined {
  return findSupportedLanguage(value);
}

export function parseSupportedLanguageOrDefault(
  value: string,
): SupportedLanguage {
  return findSupportedLanguage(value) ?? SupportedLanguage.English;
}

function findSupportedLanguage(value: string): SupportedLanguage | undefined {
  if (value === '') {
    return;
  }

  if (Object.values(SupportedLanguage).includes(value as SupportedLanguage)) {
    return value as SupportedLanguage;
  }

  // Special handling for Norwegian Nynorsk (nn)
  if (value.toLowerCase().startsWith('nn')) {
    return SupportedLanguage.Norwegian;
  }

  const language = Object.values(SupportedLanguage).find(supportedLanguage => {
    // Handle different casing of the value
    if (value.toLowerCase() === supportedLanguage.toLowerCase()) {
      return true;
    }

    // Handle different underscore spacing
    if (
      value.replace(new RegExp('_', 'g'), () => '-').toLowerCase() ===
      supportedLanguage.toLowerCase()
    ) {
      return true;
    }

    // Handle the cases of zh-hans, pt, en, etc, in the beggining of the string
    if (supportedLanguage.toLowerCase().indexOf(value.toLowerCase()) === 0) {
      return true;
    }

    // Handle the cases sv-SE (full locales) and non-standard ones like zh-CN
    if (
      value
        .replace(new RegExp('_', 'g'), () => '-')
        .toLowerCase()
        .split('-')[0] === supportedLanguage.toLowerCase().split('-')[0]
    ) {
      return true;
    }

    return false;
  });

  return language;
}
